export default "__VITE_ASSET__Q4T9h_ch__"